import { useQuery } from '@tanstack/react-query';
import { appointmentsApi } from '../services/api';

export function useAppointments() {
  return useQuery({
    queryKey: ['appointments'],
    queryFn: async () => {
      const response = await appointmentsApi.getAll();
      return response.data;
    },
  });
}

export function useAppointment(id: number) {
  return useQuery({
    queryKey: ['appointments', id],
    queryFn: async () => {
      const response = await appointmentsApi.getById(id);
      return response.data;
    },
    enabled: !!id,
  });
}
